<section class="trinka-banner section-pd-sm d-lg-block d-none">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">{{ title }}</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a *ngIf="browser === 'chrome'" id="GCChromeButton" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank" class="white-btn">
                    <img src="/assets/images/NewChromeFicon.svg" loading="lazy" decoding="async" width="32" height="32" alt="chrome"> 安裝到 Chrome
                    </a>
                    <a *ngIf="browser === 'firefox'" id="GCFirFoxButton" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" class="white-btn">
                    <img src="/assets/images/NewFirefoxFicon.svg" loading="lazy" decoding="async" width="32" height="32" alt="firefox"> 安裝到 Firefox
                    </a>
                    <a *ngIf="browser === 'edge'" id="GCEdgeButton" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank" class="white-btn">
                    <img src="/assets/images/EdgeWhite_BGAndOutline.svg" loading="lazy" decoding="async" width="32" height="32" alt="edge"> 安裝到 Edge
                    </a>
                </div>
            </div>
        </div>  
    </div>
</section>